import styled from 'styled-components';

const MissingInfoWrapper = styled.div`
  width: 100%;
`;

export { MissingInfoWrapper };
